(function(){
  /* Le visiteur doit arriver sur l'offre. Le navigateur restaure sinon la position
     du dernier passage, ce qui le dépose au milieu des avis. On garde l'ancre
     quand elle est explicite, pour que « Lire les avis » continue de fonctionner. */
  if ('scrollRestoration' in history && !window.location.hash) {
    history.scrollRestoration = 'manual';
  }
  var thisScript = document.currentScript;
  var root = (thisScript && thisScript.closest('.gs')) || document.querySelector('.gs') || document;
  var gsEl = document.querySelector('.gs');
  /* Galerie : dots + suivi au scroll */
  var track = root.querySelector('#gs-gallery'), dotsWrap = root.querySelector('#gs-gallery-dots');
  var slides = track ? [].slice.call(track.querySelectorAll('.gs-gallery__slide')) : [];
  var dots = dotsWrap ? [].slice.call(dotsWrap.querySelectorAll('.gs-dot')) : [];
  if(track && dotsWrap){
    var thumbs = root.querySelector('#gs-thumbs');
    function majOmbres(){
      if(!thumbs || !dotsWrap) return;
      var reste = dotsWrap.scrollWidth - dotsWrap.clientWidth - dotsWrap.scrollLeft;
      thumbs.classList.toggle('has-next', reste > 6);
      thumbs.classList.toggle('has-prev', dotsWrap.scrollLeft > 6);
    }
    /* amene la vignette a gauche de la bande : on decouvre ainsi les suivantes */
    function calerVignette(d){
      if(!dotsWrap) return;
      var visibles = dots.filter(function(x){ return !x.hidden; });
      var i = visibles.indexOf(d);
      var cible = (i > 0 ? visibles[i - 1] : d);   /* on laisse depasser la precedente */
      dotsWrap.scrollTo({ left: Math.max(0, cible.offsetLeft - dotsWrap.offsetLeft), behavior:'smooth' });
      setTimeout(majOmbres, 420);
    }
    dots.forEach(function(d){ d.addEventListener('click', function(){
      var s=slides[+this.dataset.idx];
      if(s) track.scrollTo({left:s.offsetLeft-track.offsetLeft, behavior:'smooth'});
      calerVignette(this);
    }); });
    if(dotsWrap){ dotsWrap.addEventListener('scroll', majOmbres, {passive:true}); }
    window.addEventListener('resize', majOmbres);
    setTimeout(majOmbres, 300);
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting&&e.intersectionRatio>0.6){ var i=slides.indexOf(e.target); dots.forEach(function(d,j){ d.classList.toggle('gs-dot--active', j===i); }); if(dots[i]) calerVignette(dots[i]); } }); }, {root:track, threshold:[0.6]});
    slides.forEach(function(s){ io.observe(s); });
  }
  /* Compte à rebours : échéance réelle, le bandeau se retire de lui-même après */
  var compteurs = [].slice.call(root.querySelectorAll('.gs-urgence'));
  if(compteurs.length){
    var deuxChiffres = function(n){ return (n < 10 ? '0' : '') + n; };
    var battre = function(){
      compteurs.forEach(function(el){
        var fin = Date.parse(el.getAttribute('data-fin'));
        var reste = fin - Date.now();
        if(!(reste > 0)){ el.hidden = true; return; }
        var j = Math.floor(reste/86400000), h = Math.floor(reste/3600000)%24,
            m = Math.floor(reste/60000)%60, s = Math.floor(reste/1000)%60;
        el.querySelector('.gs-urgence__temps').textContent =
          (j ? j + 'j ' : '') + h + 'h ' + deuxChiffres(m) + 'min ' + deuxChiffres(s) + 's';
        el.hidden = false;
      });
    };
    battre();
    setInterval(battre, 1000);
  }
  /* Sélecteur d'offre : bascule la CTA + la galerie */
  var offers = root.querySelectorAll('.gs-offer');
  var ctaBundle = root.querySelector('#gs-cta-bundle');
  var formSingle = root.querySelector('#gs-form-single');
  var bundleSlides = slides.filter(function(s){ return s.classList.contains('gs-gallery__slide--bundle'); });
  var bundleDots = dots.filter(function(d){ return d.classList.contains('gs-dot--bundle'); });
  var simplesSlides = slides.filter(function(s){ return !s.classList.contains('gs-gallery__slide--bundle'); });
  var simplesDots   = dots.filter(function(d){ return !d.classList.contains('gs-dot--bundle'); });
  function setBundleGallery(on){
    /* Une offre, une galerie. Laisser les deux jeux d'images côte à côte décalait
       le carrousel et gardait la vignette du tome en surbrillance. */
    bundleSlides.forEach(function(s){ on ? s.removeAttribute('hidden') : s.setAttribute('hidden',''); });
    bundleDots.forEach(function(d){ on ? d.removeAttribute('hidden') : d.setAttribute('hidden',''); });
    simplesSlides.forEach(function(s){ on ? s.setAttribute('hidden','') : s.removeAttribute('hidden'); });
    simplesDots.forEach(function(d){ on ? d.setAttribute('hidden','') : d.removeAttribute('hidden'); });
    if(!track) return;
    var vue = bundleSlides.filter(function(s){ return s.classList.contains('gs-gallery__slide--vue'); })[0];
    var target = on ? (vue || bundleSlides[0]) : simplesSlides[0];
    /* Repositionnement insistant : quelque chose remet le carrousel à zéro juste
       après le changement d'offre, alors on vérifie qu'on a bien atterri et on
       recommence tant que ce n'est pas le cas, pendant une seconde et demie. */
    var essais = 0;
    var poser = function(){
      essais++;
      if(!target || target.hasAttribute('hidden')) return true;
      var vise = Math.max(0, target.offsetLeft - track.offsetLeft);
      if(Math.abs(track.scrollLeft - vise) > 8){
        var snap = track.style.scrollSnapType;
        track.style.scrollSnapType = 'none';
        track.scrollLeft = vise;
        requestAnimationFrame(function(){ track.style.scrollSnapType = snap || ''; });
      }
      var i = slides.indexOf(target);
      dots.forEach(function(d, j){ d.classList.toggle('gs-dot--active', j === i); });
      if(dots[i] && dotsWrap){
        dotsWrap.scrollTo({ left: Math.max(0, dots[i].offsetLeft - dotsWrap.offsetLeft), behavior:'smooth' });
      }
      return Math.abs(track.scrollLeft - vise) <= 8 && essais > 3;
    };
    var minuteur = setInterval(function(){
      if(poser() || essais > 14) clearInterval(minuteur);
    }, 100);
    requestAnimationFrame(poser);
  }
  /* Sur mobile la galerie est deja passee quand on choisit son offre : les visuels
     changeaient sans que personne ne le voie. On remonte du strict minimum pour que
     la bande de vignettes rentre dans l'ecran, sans jamais perdre la carte cliquee. */
  var bandeVignettes = root.querySelector('#gs-thumbs');
  var galerie = root.querySelector('.gs-gallery');
  function devoilerGalerie(carte, versBundle){
    if(!bandeVignettes || !carte) return;
    var H = window.innerHeight, rv = bandeVignettes.getBoundingClientRect();
    if(rv.top >= 0 && rv.bottom <= H) return;            /* deja sous les yeux */
    /* on garde sous les yeux la carte ET le bouton d'achat, sinon on decouvre
       les visuels mais on repousse le bouton juste sous la ligne de flottaison */
    var bas = carte.getBoundingClientRect().bottom;
    var cta = versBundle ? ctaBundle : formSingle;
    if(cta){ bas = Math.max(bas, cta.getBoundingClientRect().bottom); }
    var hautVignettes = rv.top + window.scrollY;
    var cible = bas + window.scrollY - H + 14;
    if(cible > hautVignettes) return;                   /* les trois ne tiennent pas : on ne bouge pas */
    if(cible >= window.scrollY) return;                 /* on ne descend jamais */
    window.scrollTo({ top: Math.max(0, cible), behavior:'smooth' });
  }
  function signalerChangement(){
    if(!galerie) return;
    galerie.classList.remove('gs-gallery--maj');
    void galerie.offsetWidth;                            /* relance l'animation */
    galerie.classList.add('gs-gallery--maj');
    setTimeout(function(){ galerie.classList.remove('gs-gallery--maj'); }, 2200);
  }
  offers.forEach(function(o){ o.addEventListener('click', function(){
    var dejaActive = o.classList.contains('is-active');
    offers.forEach(function(x){ x.classList.toggle('is-active', x===o); var r=x.querySelector('input'); if(r) r.checked=(x===o); });
    var b = o.dataset.offer==='bundle';
    if(gsEl) gsEl.classList.toggle('is-bundle', b);
    if(formSingle) formSingle.style.display = b?'none':'block';
    var duo = o.dataset.offer==='duo';
    var ctaDuo = root.querySelector('#gs-cta-duo');
    if(ctaDuo) ctaDuo.style.display = duo?'block':'none';
    if(formSingle) formSingle.style.display = (b||duo)?'none':'block';
    if(ctaBundle) ctaBundle.style.display = b?'block':'none';
    setBundleGallery(b);
    majStickyOffre();
    if(!dejaActive){
      if(b){
        /* La Collection change toute la galerie : on ramène le visiteur en haut,
           sinon il choisit sans jamais voir ce qu'il vient de débloquer. */
        var haut = root.querySelector('.gs-hero') || o;
        try { haut.scrollIntoView({behavior:'smooth', block:'start'}); }
        catch(err){ haut.scrollIntoView(true); }
      } else {
        devoilerGalerie(o, b);
      }
      signalerChangement();
    }
  }); });

  /* ---- Barre d'achat collante (mobile) ----
     Elle ne duplique aucune logique d'achat : elle relaie le clic vers le bouton
     de l'offre choisie, pour rester juste même si les offres changent. */
  var sticky     = root.querySelector('#gs-sticky');
  var stickyNom  = root.querySelector('#gs-sticky-nom');
  var stickyPrix = root.querySelector('#gs-sticky-prix');
  var stickyBtn  = root.querySelector('#gs-sticky-btn');
  var ancreCta   = root.querySelector('#gs-cta-ancre');
  var blocFinal  = root.querySelector('.gm-final, .gs-final');
  var ctaDuoBloc = root.querySelector('#gs-cta-duo');

  function ctaActuelle(){
    var candidats = [ctaBundle, ctaDuoBloc, formSingle];
    for(var i = 0; i < candidats.length; i++){
      var c = candidats[i];
      if(c && c.offsetParent !== null) return c;
    }
    return formSingle;
  }
  function majStickyOffre(){
    if(!sticky) return;
    var active = root.querySelector('.gs-offer.is-active');
    if(!active) return;
    var nom = active.querySelector('.gs-offer__name');
    var prix = active.querySelector('.gs-offer__price strong');
    if(nom && stickyNom)  stickyNom.textContent  = nom.textContent.trim();
    if(prix && stickyPrix) stickyPrix.textContent = prix.textContent.trim();
  }
  function majSticky(){
    if(!sticky || !ancreCta) return;
    /* visible une fois le bouton principal passé, masquée sur le rappel final
       pour éviter deux boutons d'achat côte à côte */
    var apresCta = ancreCta.getBoundingClientRect().bottom < 0;
    var surFinal = false;
    if(blocFinal){
      var rf = blocFinal.getBoundingClientRect();
      surFinal = rf.top < window.innerHeight * 0.92;
    }
    sticky.hidden = !(apresCta && !surFinal);
  }
  if(sticky && stickyBtn){
    majStickyOffre();
    stickyBtn.addEventListener('click', function(){
      var bloc = ctaActuelle();
      var bouton = bloc ? bloc.querySelector('button') : null;
      /* duo incomplet : on remonte au choix des tomes plutôt que de ne rien faire */
      if(!bouton || bouton.disabled){
        var offres = root.querySelector('#gs-offers');
        if(offres) offres.scrollIntoView({behavior:'smooth', block:'center'});
        return;
      }
      bouton.click();
    });
    window.addEventListener('scroll', majSticky, {passive:true});
    window.addEventListener('resize', majSticky);
    majSticky();
  }
  /* Duo : les vignettes vivent dans un <label> qui capte les clics, on les pilote donc à la main */
  var duoTuiles = [].slice.call(root.querySelectorAll('.gs-duo__choix'));
  var duoAide = root.querySelector('#gs-duo-aide');
  var duoBouton = root.querySelector('#gs-duo-ajout');
  function duoChoisis(){ return duoTuiles.filter(function(t){ return t.classList.contains('is-choisi'); }); }
  function majDuo(){
    var n = duoChoisis().length;
    if(duoAide) duoAide.textContent = n === 0 ? 'Choisissez deux tomes'
                                    : n === 1 ? 'Encore un tome'
                                    : 'Votre duo est prêt';
    if(duoBouton){ duoBouton.disabled = (n !== 2); duoBouton.style.opacity = n === 2 ? '1' : '.5'; }
  }
  function basculer(t){
    var actif = t.classList.contains('is-choisi');
    if(!actif && duoChoisis().length >= 2){
      var premier = duoChoisis()[0];            /* déjà deux : le plus ancien laisse sa place */
      premier.classList.remove('is-choisi'); premier.setAttribute('aria-checked','false');
    }
    t.classList.toggle('is-choisi', !actif);
    t.setAttribute('aria-checked', String(!actif));
    majDuo();
  }
  duoTuiles.forEach(function(t){
    t.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); basculer(t); });
    t.addEventListener('keydown', function(e){
      if(e.key === ' ' || e.key === 'Enter'){ e.preventDefault(); e.stopPropagation(); basculer(t); }
    });
  });
  majDuo();
  if(duoBouton){
    duoBouton.addEventListener('click', function(){
      var ids = duoChoisis().map(function(t){ return t.getAttribute('data-variant'); });
      if(ids.length !== 2 || duoBouton.classList.contains('is-loading')) return;
      duoBouton.classList.add('is-loading');
      duoBouton.textContent = 'Un instant…';
      fetch('/cart/add.js', { method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ items: ids.map(function(id){ return { id: id, quantity: 1 }; }) })
      }).then(function(){ window.location.href = '/cart'; })
        .catch(function(){ duoBouton.classList.remove('is-loading'); duoBouton.textContent = 'Ajouter au panier'; });
    });
  }
  /* Présélection par l'adresse : ?offre=collection ou ?offre=duo permet d'envoyer
     une publicité directement sur la bonne offre, galerie et bouton compris. */
  (function(){
    var demande = new URLSearchParams(window.location.search).get('offre');
    if(!demande) return;
    /* noms lisibles dans les publicités -> noms techniques des cartes */
    var alias = { collection:'bundle', complete:'bundle', bundle:'bundle',
                  duo:'duo', deux:'duo', seul:'single', single:'single', tome:'single' };
    var cle = alias[demande.toLowerCase()] || demande.toLowerCase();
    var cible = root.querySelector('.gs-offer[data-offer="' + cle + '"]');
    if(!cible || cible.classList.contains('is-active')) return;
    var poser = function(){
      cible.click();
      /* le clic remonte en haut : inutile ici, on y est déjà */
      window.scrollTo(0, 0);
    };
    if(document.readyState === 'complete') poser();
    else window.addEventListener('load', poser);
  })();

  /* Raccourcis vers la Collection : sélectionnent l'offre, basculent la galerie,
     puis remontent en haut. Même comportement qu'un clic sur la carte d'offre. */
  var bundleOffer = root.querySelector('.gs-offer[data-offer="bundle"]');
  function allerVersCollection(e){
    if(e) e.preventDefault();
    if(!bundleOffer) return;
    bundleOffer.click();
    var target = root.querySelector('.gs-hero') || bundleOffer;
    try { target.scrollIntoView({behavior:'smooth', block:'start'}); }
    catch(err){ target.scrollIntoView(true); }
  }
  ['#gs-see-bundle', '#gs-voir-collection'].forEach(function(sel){
    var el = root.querySelector(sel);
    if(el && bundleOffer) el.addEventListener('click', allerVersCollection);
  });
})();

  /* Feuilletage : défilement par planche, au clic sur les flèches */
  (function(){
    var piste = document.getElementById('gs-feuillet-piste');
    var prec  = document.getElementById('gs-feuillet-prec');
    var suiv  = document.getElementById('gs-feuillet-suiv');
    if(!piste || !prec || !suiv) return;
    function pas(){
      var v = piste.querySelector('.gs-feuillet__vue');
      if(!v) return piste.clientWidth * 0.9;
      var st = getComputedStyle(piste);
      return v.getBoundingClientRect().width + (parseFloat(st.columnGap || st.gap) || 20);
    }
    function etat(){
      prec.disabled = piste.scrollLeft <= 4;
      suiv.disabled = piste.scrollLeft >= piste.scrollWidth - piste.clientWidth - 4;
    }
    prec.addEventListener('click', function(){ piste.scrollBy({left:-pas(), behavior:'smooth'}); });
    suiv.addEventListener('click', function(){ piste.scrollBy({left: pas(), behavior:'smooth'}); });
    piste.addEventListener('scroll', etat, {passive:true});
    window.addEventListener('resize', etat);
    etat();
  })();

  /* Galerie : index mémorisé, avance en boucle, swipe, agrandissement */
  (function(){
    var piste = document.getElementById('gs-gallery');
    if(!piste) return;
    var idx = 0, enCours = false;

    function vues(){
      return [].slice.call(piste.querySelectorAll('.gs-gallery__slide')).filter(function(s){ return !s.hidden; });
    }
    function aller(i){
      var v = vues(); if(!v.length) return;
      idx = ((i % v.length) + v.length) % v.length;
      enCours = true;
      piste.scrollTo({ left: v[idx].offsetLeft - piste.offsetLeft, behavior:'smooth' });
      setTimeout(function(){ enCours = false; }, 420);
      var fle = document.getElementById('gs-fle-suiv');
      if(fle) fle.classList.toggle('is-fin', idx === v.length - 1);
    }
    function suivante(){ aller(idx + 1); }
    function precedente(){ aller(idx - 1); }

    /* si l'acheteur fait défiler à la main, on se recale sur ce qu'il voit */
    var t;
    piste.addEventListener('scroll', function(){
      if(enCours) return;
      clearTimeout(t);
      t = setTimeout(function(){
        var v = vues(), g = piste.scrollLeft + piste.offsetLeft, best = 0, d = 1e9;
        v.forEach(function(s,i){ var e = Math.abs(s.offsetLeft - g); if(e < d){ d = e; best = i; } });
        idx = best;
        var fle = document.getElementById('gs-fle-suiv');
        if(fle) fle.classList.toggle('is-fin', idx === v.length - 1);
      }, 130);
    }, {passive:true});

    piste.addEventListener('click', function(e){
      if(e.target.closest('.gs-loupe') || e.target.closest('.gs-fle-gal')) return;
      suivante();
    });

    var x0 = null, y0 = null, t0 = 0;
    piste.addEventListener('touchstart', function(e){
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; t0 = Date.now();
    }, {passive:true});
    piste.addEventListener('touchend', function(e){
      if(x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if(Date.now() - t0 < 700 && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3){
        if(dx < 0) suivante(); else precedente();
      }
      x0 = null;
    }, {passive:true});

    var fs = document.getElementById('gs-fle-suiv');
    if(fs) fs.addEventListener('click', function(e){ e.stopPropagation(); suivante(); });
    var fp = document.getElementById('gs-fle-prec');
    if(fp) fp.addEventListener('click', function(e){ e.stopPropagation(); precedente(); });

    /* agrandissement */
    var voile = null, agrandi = false;
    function ajuster(gros){
      if(!voile) return;
      var z = voile.querySelector('img');
      agrandi = !!gros;
      var cote = Math.min(window.innerWidth, window.innerHeight) - 48;
      z.style.width = (agrandi ? cote * 2 : cote) + 'px';
      z.style.height = 'auto';
      z.style.cursor = agrandi ? 'zoom-out' : 'zoom-in';
      voile.classList.toggle('est-agrandi', agrandi);
      requestAnimationFrame(function(){
        voile.scrollLeft = Math.max(0, (voile.scrollWidth - voile.clientWidth) / 2);
        voile.scrollTop  = Math.max(0, (voile.scrollHeight - voile.clientHeight) / 2);
      });
    }
    function ouvrir(){
      var v = vues(); var src = v[idx] && v[idx].querySelector('img');
      if(!src) return;
      if(!voile){
        voile = document.createElement('div');
        voile.className = 'gs-zoom';
        voile.innerHTML = '<button type="button" class="gs-zoom__fermer" aria-label="Fermer">\u00d7</button>' +
                          '<div class="gs-zoom__cadre"><img alt=""></div>' +
                          '<p class="gs-zoom__aide">Faites glisser pour explorer</p>';
        document.body.appendChild(voile);
        voile.addEventListener('click', function(e){
          if(e.target.tagName === 'IMG'){ ajuster(!agrandi); return; }
          if(!e.target.closest('.gs-zoom__cadre')) fermer();
        });
      }
      var z = voile.querySelector('img');
      z.removeAttribute('src');                 /* évite d'afficher la précédente */
      voile.classList.add('is-on');
      voile.classList.remove('est-charge','est-agrandi');
      agrandi = false;
      document.documentElement.style.overflow = 'hidden';
      var u = (src.currentSrc || src.src).replace(/([?&])width=\d+/, '$1width=2400');
      if(u.indexOf('width=') < 0) u += (u.indexOf('?') < 0 ? '?' : '&') + 'width=2400';
      z.onload = function(){
        ajuster(false);
        voile.classList.add('est-charge');
      };
      z.src = u;
    }
    function fermer(){
      if(voile){ voile.classList.remove('is-on','est-charge','est-agrandi'); voile.querySelector('img').removeAttribute('src'); }
      document.documentElement.style.overflow = '';
    }
    var loupe = document.getElementById('gs-loupe');
    if(loupe) loupe.addEventListener('click', function(e){ e.stopPropagation(); ouvrir(); });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape') fermer();
      if(e.key === 'ArrowRight') suivante();
      if(e.key === 'ArrowLeft') precedente();
    });
    aller(0);
  })();